import { render, staticRenderFns } from "./Infobar.vue?vue&type=template&id=d0614fd4&scoped=true"
import script from "./Infobar.vue?vue&type=script&lang=js"
export * from "./Infobar.vue?vue&type=script&lang=js"
import style0 from "./Infobar.vue?vue&type=style&index=0&id=d0614fd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0614fd4",
  null
  
)

export default component.exports